import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, NgForm} from "@angular/forms";
import {lastValueFrom} from "rxjs";
import {InternalSettingDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-internal-setting-edit",
    templateUrl: "./internal-setting-edit.component.html",
    styleUrls: ["./internal-setting-edit.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InternalSettingEditComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private readonly api: PerFormaAPIService,
        private formBuilder: FormBuilder
    ) {}

    async ngOnInit() {
        this.route.queryParams.subscribe(p => {
            if (p.created === "true") {
                this.successMsg = "Created setting";
            }
        });
        await this.checkEditMode();
    }

    internalSetting: InternalSettingDto = {
        KeyID: undefined,
        KeyName: "",
        KeyValue: "",
        IsBoolean: false,
        BoolValue: false
    };

    isEditMode = false;
    loading = true;
    successMsg = "";
    errorMsg = "";

    // Alert state
    alertMessage = "";
    alertType: "success" | "error" | "warning" = "success";

    save = async (frm: NgForm) => {
        this.successMsg = "";
        this.errorMsg = "";

        frm.control.markAllAsTouched();

        if (!frm.valid) return;

        this.loading = true;

        try {
            if (this.isEditMode) {
                await lastValueFrom(this.api.putApiConfigureInternal(this.internalSetting));
                frm.control.markAsUntouched();
                this.successMsg = "Modified setting";
            } else {
                const resp = await lastValueFrom(this.api.postApiConfigureInternal(this.internalSetting));
                this.successMsg = "Created setting";
                this.router.navigateByUrl(`/configure/internalsettingedit?id=${resp.KeyID}&created=true`);
            }

            frm.control.markAsUntouched();
            this.successMsg = "";
        } catch (e: any) {
            if (e.error?.ModelState?.status?.includes("FailInternalSettingNameAlreadyExists")) {
                this.errorMsg = "An setting already exists with the name specified";
            } else if (e.error?.ModelState?.status?.includes("FailInternalSettingNotAllowed")) {
                this.errorMsg = "Not authorized to create/modify this setting";
            } else {
                this.errorMsg = e.error?.Message;
            }
        } finally {
            this.loading = false;
        }
    };

    remove = async () => {
        if (!confirm("Are you sure you want to delete this setting?")) {
            return;
        }
        try {
            this.loading = true;
            await lastValueFrom(this.api.deleteApiConfigureInternalId(Number(this.internalSetting.KeyID)));
            this.router.navigateByUrl("/configure/internalsetting");
        } catch (e: any) {
            if (e.error?.ModelState?.status?.includes("FailInternalSettingNotAllowed")) {
                this.errorMsg = "Not authorized to delete this setting";
            } else {
                this.errorMsg = e.error?.Message;
            }
        } finally {
            this.loading = false;
        }
    };

    checkEditMode = async () => {
        const id = this.route.snapshot.queryParamMap.get("id");
        if (!id) {
            this.loading = false;
            return;
        }

        this.isEditMode = true;

        try {
            this.internalSetting = await lastValueFrom(this.api.getApiConfigureInternalId(Number(id)));
        } finally {
            this.loading = false;
        }
    };
}
